import { render } from "./ModuleFinal.vue?vue&type=template&id=5685231e"
import script from "./ModuleFinal.vue?vue&type=script&lang=js"
export * from "./ModuleFinal.vue?vue&type=script&lang=js"

import "./ModuleFinal.vue?vue&type=style&index=0&id=5685231e&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__